module.exports = __webpack_public_path__ + "static/media/IMG_20201031_0009.3a9fc290.jpg";